import { render, staticRenderFns } from "./OrganizationMdtRoomUpdate.vue?vue&type=template&id=4d921990&scoped=true"
import script from "./OrganizationMdtRoomUpdate.vue?vue&type=script&lang=js"
export * from "./OrganizationMdtRoomUpdate.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMdtRoomUpdate.vue?vue&type=style&index=0&id=4d921990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d921990",
  null
  
)

export default component.exports